import { signOut, useSession } from 'next-auth/react';
import { useEffect } from 'react';

const RefreshTokenHandler = (props: {
  setInterval: (arg0: number) => void;
}) => {
  const { data: session } = useSession();
  const timeNow = Math.floor(new Date().getTime() / 1000);

  useEffect(() => {
    if (session) {
      if (!session.token) signOut();
      const timeRemaining = session.accessExpires - 1 - timeNow;

      props.setInterval(timeRemaining > 0 ? timeRemaining : 0);
    }
  }, [session, props, timeNow]);

  return null;
};

export default RefreshTokenHandler;
